import React from "react"
import { grey800 } from "material-ui/styles/colors"
import { IDeviceDocument } from "../../../../models"
import * as api from "../../../../api"
import { FontIcon } from "material-ui"
import AddDeviceDialog from "../../../device/AddDeviceDialog"
import * as deviceActions from "../../../../actions/DeviceActions"

interface IProps {
    readonly: boolean
    deviceId: string
}
interface IState {
    open: boolean
    loadingDevice: boolean
    device: IDeviceDocument
}

export default class ExceptionBodyDeviceDialog extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            loadingDevice: false,
            device: null
        }
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.props.deviceId !== nextProps.deviceId &&
            this.setState({
                open: false,
                loadingDevice: false,
                device: null
            })
    }

    getDeviceInfo() {
        this.state.open && this.props.deviceId && !this.state.device &&
            this.setState({ loadingDevice: true }, () =>
                api.getDevice(this.props.deviceId).then(res =>
                    this.setState({
                        loadingDevice: false,
                        device: res.data
                    })
                )
            )
    }

    render() {
        return (
            <div style={{ marginLeft: 5 }}>
                <FontIcon
                    style={{ fontSize: 16 }}
                    className="fa fa-external-link"
                    color={grey800}
                    onClick={() => this.setState({ open: true }, () => this.getDeviceInfo())}
                />
                {this.state.open && this.state.device && !this.state.loadingDevice &&
                    <AddDeviceDialog
                        editableDevice={this.state.device}
                        handleAdd={null}
                        handleUpdate={device =>
                            deviceActions.updateDevice(device).then(() =>
                                this.setState({ device: null })
                            )
                        }
                        handleClose={() => this.setState({ open: false })}
                        readonly={this.props.readonly}
                    />
                }
            </div>
        )
    }
}